export const getWindowLocationHref = () => {
  return window.location.href
}

export const getDocumentReferrer = () => {
  return document.referrer
}
